var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"upmb-Menu",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_c('div',{staticClass:"upmb-Menu_Dot"}),_c('div',{staticClass:"upmb-Menu_Dot"}),_c('div',{staticClass:"upmb-Menu_Dot"})])
}
var staticRenderFns = []

export { render, staticRenderFns }